import SchemaMarkup from "../Components/SchemaMarkup";

const BlogPostingSchema = ({ blog }) => {
  if (!blog) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",

    "@id": `https://msayurved.com/blog/${blog.slug}#blogposting`,

    "url": `https://msayurved.com/blog/${blog.slug}`,

    "headline": blog.title,

    "description": blog.intro,

    "image": blog.img,

    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://msayurved.com/blog/${blog.slug}`
    },

    "author": {
      "@id": "https://msayurved.com/#person"
    },

    "publisher": {
      "@id": "https://msayurved.com/#organization"
    },

    "isPartOf": {
      "@id": "https://msayurved.com/blog/#blog"
    },

    "inLanguage": "en-IN"
  };

  return <SchemaMarkup data={schema} />;
};

export default BlogPostingSchema;